import noNet from './noNet'

function install (Vue) {
  Object.defineProperty(Vue.prototype, '$nonet', {
    get () {
      let div = document.createElement('div')
      document.body.appendChild(div)
      return function (show, reload) {
        const Constructor = Vue.extend(noNet)
        new Constructor({
          data () {
            return {
              show: show
            }
          },
          methods: {
            reload: reload
          }
        }).$mount(div)
      }
    }
  })
}

export default install



// WEBPACK FOOTER //
// ./src/components/emptypage/noNet/index.js